var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 footer-copyright"},[_c('p',{staticClass:"mb-0"},[_vm._v("Version 1.1 | Build 16502023")]),_c('p',{staticClass:"mb-0"},[_vm._v("Copyright 2023 ©infrabau GmbH")])]),_c('div',{staticClass:"col-md-6"})])])])])
}]

export { render, staticRenderFns }